import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=2db32c3b&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"
import style0 from "./Admin.vue?vue&type=style&index=0&id=2db32c3b&prod&scoped=true&lang=css"
import style1 from "./Admin.vue?vue&type=style&index=1&id=2db32c3b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db32c3b",
  null
  
)

export default component.exports